import { useState, useEffect, useRef, useLayoutEffect, useContext } from "react"
import { formatTimestamp, setImageUrl } from "../utils"
import { BsClockHistory, BsFillReplyFill, BsReplyFill } from "react-icons/bs"
import { IoMdDoneAll, IoMdChatboxes } from "react-icons/io"
import { IoCopyOutline } from "react-icons/io5"
import { MdClose, MdOutlineDeleteOutline } from "react-icons/md"
import { CiEdit } from "react-icons/ci"
import { HiOutlineDotsVertical } from "react-icons/hi"
import { AccountContext } from "../contexts/AccountContexts"
import ImageViewer from "./ImageComponents"
import { onBannedUserMessage, onBannedWarning, onCategoryChangeMessage, onDeleteMessage, onEditMessage, onMessagesRead, onNewMessage, onNewMessageUser, onTicketCompletedMessage, onUsersOnline, sendDeleteMessage, sendEditMessage } from "../utils/messagingUtils"
import { FileInputExtended, TextLargeInput } from "./Input-Components"
import { QuickReplyWindowExtended } from "./QuickReplyComponents"
import { TicketFastCompleteModal } from "./TicketComponents"
import { TbGhost2 } from "react-icons/tb"
import { requestChat } from "../requests/chat_requests"
import { TimePassedComponent } from "./TimeComponents"
import { ContentContext } from "../contexts/ContentContext"
import { FiArrowDownCircle } from "react-icons/fi"
import { useTranslation, Trans } from "react-i18next"
import { devLog } from "../utils/loggerUtils"
import { NotificationContext } from "../contexts/NotificationContexts"
import { requestFetchTicketsByTimestamp } from "../requests/ticket_requests"
import { NavLink } from "react-router-dom"
import { requestDevs } from "../requests/users_requests"


export function GenericMessage({ socket, attr, userAttr, dev, chatId, notesId, isNotes = false, end = true, replyTo, setReplyTo }) {
    const { t } = useTranslation(['edit', 'common'])
    const { handleCopyToClipboard } = useContext(ContentContext)

    const menuRef = useRef(null);
    const messageRef = useRef(null);
    const time = formatTimestamp(attr.timestamp * 1000)

    const [menuOpen, setMenuOpen] = useState(false);
    const [isEditMessage, setIsEditMessage] = useState(false)

    const [content, setContent] = useState(attr.message)

    const [textInputId, setTextInputId] = useState(null)
    const [dragging, setDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [offsetX, setOffsetX] = useState(0);

    const handleMenuClick = () => {
        setMenuOpen(true)
        setIsEditMessage(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
            if (messageRef.current && !messageRef.current.contains(event.target)) {
                setIsEditMessage(false)
                setContent(attr.message)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDeleteMessage = () => {

        sendDeleteMessage({ socket: socket, message: attr, user: userAttr, chatId: chatId, notesId: notesId }).then((data) => {
            setMenuOpen(false)
            setIsEditMessage(false)
        })
    }

    const handleReply = () => {
        setReplyTo({...attr, sender_name: userAttr.name})
        setMenuOpen(false)
    }


    const handleEditMessage = () => {
        setMenuOpen(false);
        setIsEditMessage(true)

    }

    const handleCopy = () => {
        setMenuOpen(false);
        setIsEditMessage(false)
        handleCopyToClipboard(attr.message)
    }



    const handleOnEditSend = () => {

        sendEditMessage({ socket: socket, message: attr, new_message: content, user: userAttr, chatId: chatId, notesId: notesId }).then((data) => {
            setIsEditMessage(false)
        })
    }

    const [ctrlPressed, setCtrlPressed] = useState(false)

    useEffect(() => {
        const handleKeyPress = (event) => {
            let element = document.getElementById(textInputId)
            if (event.ctrlKey) {

                if (element !== document.activeElement) {
                    return null;
                }

                setCtrlPressed(true)

                if (event.key === 'Enter') {
                    setTimeout(() => {
                        handleOnEditSend();
                    }, 50)
                }
            }
        };

        const handleKeyUp = (event) => {
            if (event.key == "Control") {

                setCtrlPressed(false)
                if (ctrlPressed) {
                }
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        document.addEventListener('keyup', handleKeyUp);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, [content]);

    useEffect(() => {
        if (isEditMessage) {
            setTextInputId(attr.id + "-edit-message")
        }
    }, [isEditMessage])

    const goReply = (id) => {
        const messageElement = document.getElementById(id);
        if (messageElement) {
            messageElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            messageElement.classList.add("highlight");
            setTimeout(() => messageElement.classList.remove("highlight"), 1500);
        }
    }


    if (!userAttr) {
        return <></>
    }

    const isGhost = !!userAttr.type ? userAttr.type === "deleted" : false

    let bubbleBackground = ""
    if (end) {
        bubbleBackground = "bg-blue-100 dark:bg-sky-950"
    }
    else if (!end && userAttr.class === "dev" && !isNotes && !isGhost) {
        bubbleBackground = "bg-green-100 dark:bg-green-950"
    }
    else if (!end && isGhost) {
        bubbleBackground = "bg-gray-200 dark:bg-gray-700"
    }
    else {
        bubbleBackground = "bg-white dark:bg-gray-800"
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = attr.message.split(urlRegex);


    const handleMouseDown = (e) => {
        const tag = e.target.tagName.toLowerCase();
        if (["video", "button", "a", "textarea", "input", "img"].includes(tag)) return;
        setDragging(true);
        setStartX(e.clientX);
        
    };

    const handleMouseMove = (e) => {
        if (!dragging) return;
        const diff = e.clientX - startX;

        if (!end && diff > 0) {
        setOffsetX(diff > 120 ? 120 : diff);
        } else if (end && diff < 0) {
        setOffsetX(diff < -120 ? -120 : diff);
        }
    };

    const handleMouseUp = () => {
        if (!end && offsetX > 100) {
        handleReply();
        } else if (end && offsetX < -100) {
        handleReply();
        }

        setDragging(false);
        setOffsetX(0);
    };

    return(
        <div className={`chat ${end ? "chat-end" : "chat-start"}`} >
            <div className={`chat-bubble max-w-[80%] sm:max-w-[90%] group text-gray-800 dark:text-gray-300 ${bubbleBackground} `} 
                ref={messageRef} id={`${attr.id}`}
                style={{ transform: dragging && `translateX(${offsetX}px)`}}
            >
                {attr.reply_to !== null && attr.reply_to !== undefined && (
                    <div onClick={() => goReply(attr.reply_to?.id)} className="border-l-2 border-blue-500 text-sm p-1 mb-1 cursor-pointer">
                        <b>{attr.reply_to?.sender_name}</b>: {attr.reply_to?.message}
                    </div>
                )}

                {dragging && (offsetX > 40 || offsetX < -40) &&(
                    <div className={`absolute ${end ? "right-[-35px]" : "left-[-35px]"} top-1/2 -translate-y-1/2 text-blue-500 transition-opacity`}>
                        <BsReplyFill size={20} className="text-white" />
                    </div>
                )}
                
                <div className={`chat-header flex items-center gap-4 justify-between ${offsetX !== 0 ? "cursor-grabbing select-none" : "cursor-grab"}`}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                  
                >
                    <div className="flex gap-2">

                        <div className="chat-image avatar self-center">

                            <div className="w-10 rounded-full">
                                {
                                    isGhost ?
                                    <div className="w-10 h-10 rounded-full bg-gray-600 flex items-center justify-center text-white text-lg select-none">
                                        <TbGhost2 size={24} />
                                    </div>
                                    :
                                    (userAttr.avatar.length < 3 || (!dev && attr.user_class === "dev") ? // The user won't be able to view the employees' profile pictures
                                        <div className="w-10 h-10 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-lg select-none">
                                            {attr.user_class == "dev" ? "GM" : userAttr.email[0]?.toUpperCase()}
                                        </div>
                                        :
                                        <img
                                            alt={userAttr?.name + " avatar"}
                                            src={setImageUrl(userAttr.avatar)} />
                                    )
                                }
                            </div>
                        </div>
                        <div className="flex flex-col items-start">
                            <h1 className="text-gray-800 dark:text-gray-300 font-semibold">{userAttr.name} {isGhost ? "(Deleted)" : ""}</h1>
                            <div className="flex gap-1 flex-wrap">
                                <time className="text-xs opacity-100 text-gray-800 dark:text-gray-300">{time}</time>
                                <time className="text-xs opacity-100 text-gray-800 dark:text-gray-300 font-semibold min-w-24">(<TimePassedComponent timestamp={attr.timestamp * 1000} />)</time>
                            </div>
                            {
                                dev && userAttr.class === "user" &&
                                <span className={`text-[11px] font-semibold ltr:pl-0.5 rtl:pr-0.5 ${attr?.ip_origin === "NOT FOUND" ? "opacity-30" : "opacity-70"}`}>{attr?.ip_origin ? `IP: ${attr.ip_origin}` : ""}</span>
                            }
                        </div>
                    </div>
                    <div className="grid grid-rows-2 gap-[1px] justify-items-end text-gray-800 dark:text-gray-300 text-xs">
                        <div className="row-start-1 opacity-70">
                            {attr.edited && attr.user_class === "dev" &&
                                <p>({t('Edited')})</p>}
                        </div>

                        <div className="row-start-2 relative">
                            {
                                menuOpen &&
                                <ul ref={menuRef} className="absolute ltr:right-full rtl:left-full -top-12  menu border-2 bg-white dark:bg-gray-700 border-gray-100 dark:border-gray-600  opacity-100 active rounded-box text-gray-800 dark:text-gray-300 z-50">
                                    {dev && <li className="" onClick={handleCopy}><a><IoCopyOutline /> {t('Copy')} </a></li>}
                                    <li onClick={handleReply}><a><BsFillReplyFill /> {t('Reply')}</a></li>
                                    {dev && <li className={`${!end && "hidden"}`} onClick={handleEditMessage}><a><CiEdit /> {t('Edit')}</a></li>}
                                    {dev && <li className={`${!end && "hidden"}`} onClick={handleDeleteMessage}><a><MdOutlineDeleteOutline /> {t('Delete')}</a></li>}
                                </ul>
                            }
                            {
                                <button className="opacity-0 group-hover:opacity-100  ease-in-out duration-200"
                                    onClick={handleMenuClick}
                                >
                                    <HiOutlineDotsVertical size={16} />
                                </button>
                            }
                        </div>
                    </div>
                </div>
                <div className="divider before:bg-gray-300 after:bg-gray-300 dark:before:bg-gray-600 dark:after:bg-gray-600 before:h-[1px] after:h-[1px] mb-1 mt-[0px]"></div>

                <div className="text-gray-800 dark:text-gray-300 my-1">
                    {
                        !isEditMessage ?
                            isNotes ?
                                <ChatMessage message={attr.message} dev={dev} notes={isNotes} />
                                :
                                <span className="whitespace-pre-wrap text-wrap  overflow-auto">
                                    {parts.map((part, index) =>
                                        urlRegex.test(part) ? (
                                            <a
                                                key={index}
                                                href={part}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-500 hover:underline"
                                            >
                                                {part}
                                            </a>
                                        ) : (
                                            <span key={index}>{part}</span>
                                        )
                                    )}
                                </span>
                            :

                            <div className="flex flex-col gap-2  sm:w-[700px]">

                                <div className="border-[1px] border-primary/20 rounded-lg">

                                    <textarea id={textInputId} className="textarea w-full bg-inherit border-[0px] h-32 focus:border-0 active:border-0 p-1" value={content} onChange={(e) => { setContent(e.target.value) }} autoFocus={true}></textarea>

                                </div>
                                <button className={`btn btn-md w-20 ${ctrlPressed ? "bg-fuchsia-700 hover:bg-fuchsia-600 text-yellow-50" : "bg-primary hover:bg-sky-700 text-white"} border-none self-end`} onClick={handleOnEditSend}>{t('Confirm')}</button>
                            </div>
                    }
                </div>

                {(attr.attachments && attr.attachments.length !== 0) &&
                    <>
                        <div className="divider before:h-[1px] after:h-[1px] mt-4 mb-2 text-gray-800 dark:text-gray-300 text-sm opacity-50">{t('Attachments')}</div>
                        <div className="flex gap-2">
                            <ImageViewer imageUrls={attr.attachments} />
                        </div>
                    </>
                }

                <div className="mt-2 flex w-full justify-end">
                    {(attr.class !== "user" && dev && !isNotes) &&
                        (attr.read
                            ?
                            <div className="text-[#0891b2] dark:text-emerald-400">
                                <IoMdDoneAll size={16} />
                            </div>
                            :
                            <div>
                                <BsClockHistory size={12} />
                            </div>
                        )
                    }
                </div>
            </div>

        </div>
    )
}


export const ChatViewer = ({ chatId, firstPerson, socket, ticketInfo, setTicketInformation, anonUser, setAnonUser, isSendingMessage, replyTo, setReplyTo, dev = false }) => {
    const { t } = useTranslation('edit')

    const { user, devs } = useContext(AccountContext);
    const { openErrorModal, isDarkMode, openBanErrorModal } = useContext(ContentContext)
    const { reconnected } = useContext(NotificationContext)

    const chatContainerRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(true)

    const [chat, setChat] = useState([]);
    const [chatUsers, setChatUsers] = useState({});
    const [chatRenew, setChatRenew] = useState(false)
    const [chatLoading, setChatLoading] = useState(false)
    const [gotNewMessages, setGotNewMessages] = useState(false)

    const [usersOnline, setUsersOnline] = useState([])


    const _setGotNewMessages = () => {
        setGotNewMessages(true)
    }

    useEffect(() => {
        if (socket || reconnected) {

            if (reconnected) {
                devLog("chat reconnected")
            }

            socket.emit('join_chatroom', { room_id: ticketInfo.chat_id, name: user.id })

            if (dev) {
                socket.emit('join_chatroom', { room_id: `${ticketInfo.chat_id}_dev`, name: user.id })
                onNewMessage({ socket: socket, setChat: setChat, setChatUsers: setChatUsers, setTicketInformation: setTicketInformation, setGotNewMessages: _setGotNewMessages })
            }
            else {
                onNewMessageUser({ socket: socket, setChat: setChat, setChatUsers: setChatUsers, setTicketInformation: setTicketInformation, user: user, chatId: ticketInfo.chat_id, setGotNewMessages: _setGotNewMessages })
            }

            onDeleteMessage({ socket: socket, setChat: setChat, setChatUsers: setChatUsers })

            onEditMessage({ socket: socket, setChat: setChat, setChatUsers: setChatUsers })

            onMessagesRead({ socket: socket, setChat: setChat })

            onTicketCompletedMessage({ socket: socket, setChat: setChat, setChatUsers: setChatUsers, setTicketInformation: setTicketInformation })

            onCategoryChangeMessage({ socket: socket, setChat: setChat })

            onBannedUserMessage({ socket: socket, setChat: setChat, setChatUsers: setChatUsers, setAnonUser: setAnonUser })

            onBannedWarning({ socket: socket, openErrorModal: openBanErrorModal })

            onUsersOnline({ socket: socket, setUsersOnline: setUsersOnline, roomId: ticketInfo.chat_id })

        }

    }, [chatId, reconnected])


    useEffect(() => {
        // Cleanup socket connection
        return () => {
            if (socket) {
                devLog("Leaving room. CHAT", ticketInfo.id)
                socket.emit('leave_chatroom', { room_id: ticketInfo.chat_id, name: user.id });
                if (dev) {
                    socket.emit('leave_chatroom', { room_id: `${ticketInfo.chat_id}_dev`, name: user.id });
                }
            }
        }
    }, [])

    useEffect(() => {
        if (ticketInfo.chat_id || chatRenew) {
            setTimeout(() => {

                requestChat({ chatId: ticketInfo.chat_id, userClass: dev ? "dev" : "user" }).then((data) => {
                    setChat(data.chat)
                    setChatUsers(data.users)
                    setChatRenew(false)
                })
                    .catch((error) => {
                        console.error(error.status, error.message)
                        openErrorModal(error)
                    })
            }, 100)
        }

    }, [ticketInfo.chat_id, ticketInfo.assignedTo, chatRenew, user])

    const checkIfAtBottom = () => {
        if (!chatContainerRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
        const atBottom = scrollHeight - scrollTop <= clientHeight + 50; // Small buffer
        setIsAtBottom(atBottom);
        if (atBottom) {
            setGotNewMessages(false)
        }
    };

    // Scroll to the bottom of the chat window
    const scrollToBottom = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    };

    useLayoutEffect(() => {
        const chatContainer = chatContainerRef.current;
        if (chatContainer && isAtBottom) {
            // Use setTimeout to ensure it runs after rendering is complete
            setTimeout(() => {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }, 50);
        }
    }, [chat]);


    useEffect(() => {
        const chatWindow = chatContainerRef.current;
        if (!chatWindow) return;

        const handleScroll = () => {
            checkIfAtBottom();
        };

        chatWindow.addEventListener("scroll", handleScroll);
        return () => {
            chatWindow.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (isAtBottom) {
            scrollToBottom();
        }
    }, [chat, isAtBottom]);


    const handleReloadChat = async (e) => {

        setChatRenew(true)
    }

    return (
        <>
            <TicketFastCompleteModal chat={chat} user={user} ticketInfo={ticketInfo} setTicketInformation={setTicketInformation} />
            <div className="relative flex flex-col lg:min-w-[400px]  flex-1 rounded-t-xl bg-white dark:bg-gray-700 ">
                {
                    dev &&
                    <>
                        <div className="absolute top-6 ltr:left-0 rtl:right-0 avatar-group  overflow-visible  -space-x-3 hover:-space-x-2 rtl:space-x-reverse hover:scale-150 ltr:hover:translate-x-5 rtl:hover:-translate-x-5 hover:translate-y-2 z-50">
                            {
                                usersOnline.map((devId, index) =>
                                    devs[devId] &&
                                    !(user.id == devs[devId].id) &&
                                    <div key={index} className="relative">
                                        {

                                            ticketInfo.assignedTo === devId &&
                                            <div className="absolute -top-3 -left-1 -rotate-[30deg] w-6 z-10">
                                                <img src={process.env.PUBLIC_URL + "/icons8-crown-100.png"} />
                                            </div>
                                        }


                                        <div className="avatar border-gray-300 dark:border-gray-700 peer">
                                            {
                                                devs[devId].avatar.length > 3 &&
                                                <div className="w-7 ">
                                                    <img src={setImageUrl(devs[devId].avatar)} />
                                                </div>
                                            }
                                            {
                                                devs[devId].avatar.length < 3 &&
                                                <div className="w-7 h-7 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-xs p-1 select-none">
                                                    <span className="">{"GM"}</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="relative invisible peer-hover:visible ">
                                            <span className={`absolute rounded-lg px-2 py-1 font-semibold text-xs ${ticketInfo.assignedTo === devId ? "bg-orange-600 text-white" : "bg-gray-700 text-white"}`}>{devs[devId].name}</span>

                                        </div>

                                    </div>
                                )

                            }
                        </div>
                        <div className="absolute top-2 ltr:right-2 rtl:left-2 ">
                            {
                                ticketInfo.assignedTo === user.id &&
                                <span className="text-md text-red-600 dark:text-red-500">{t('Assigned to you')}</span>
                            }
                        </div>
                        <div className="absolute top-7 ltr:right-2 rtl:left-2 z-10">
                            {
                                usersOnline.includes(anonUser.id) &&
                                <span className="text-md text-green-600 dark:text-green-500">{t('User online')}</span>
                            }
                        </div>

                    </>
                }
                <h1 className="w-full text-center text-lg font-semibold mt-4 flex items-center justify-center gap-2"><IoMdChatboxes /> {t('Messages')}</h1>
                <div className="divider before:h-[1px] after:h-[1px] mb-0 h-[1px]"></div>
                <div className="flex flex-col w-full min-h-[500px] max-h-[500px] lg:min-w-[400px] rounded-lg bg-primary/5 relative "
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/bg-1000.png)`, backgroundRepeat: 'repeat', backgroundPosition: '200px -5px', backgroundSize: 'calc(56% - 0px)' }}
                >
                    <div className={`flex flex-col relative w-full min-h-[500px] max-h-[500px] lg:min-w-[400px] overflow-auto overscroll-auto sm:overscroll-contain pt-3 gap-3 ${isDarkMode && "bg-opacity-60 bg-black"}`} ref={chatContainerRef}>
                        {isSendingMessage && (
                            <div className="w-full sticky left-0 top-[94%] z-50 bg-white/30 flex gap-2 justify-end items-center rounded-md text-end px-12 text-white">
                                <span className="loading loading-bars loading-md"></span>
                                <span>{t('Sending message')}</span>
                            </div>
                        )}
                        <div className={`${isSendingMessage && "mb-8"}`}>
                        {(!chat || chat.length === 0 || chatUsers.length === 0) ?
                            <h1 className="w-full text-center ltr:italic text-sm">{t('No new messages')}</h1>
                            :
                            chat.map((message, index) =>
                                (message.type && message.type === "assignment" && user.class === "dev") &&
                                <DeveloperAssignedMessage key={message.id} fromAttr={chatUsers[message.from_user]} toAttr={chatUsers[message.to_user]} />
                                ||
                                (message.type && message.type === "category_change") &&
                                <CategoryChangedMessage key={message.id} message={message} />
                                ||
                                (message.type && message.type === "ban_message" && user.class === "dev") &&
                                <BannedUserMessage key={message.id} message={message} />
                                ||
                                (message.type && message.type === "completion") &&
                                <TicketCompletedMessage key={message.id} message={message} users={chatUsers} />
                                ||
                                (message.type && message.type === "member_resolved") &&
                                <TicketMemberResolved key={message.id} message={message} ticketInfo={ticketInfo} />
                                ||
                                (message.type && message.type === "reopened") &&
                                <TicketReopenedMessage key={message.id} message={message} users={chatUsers} />
                                ||
                                (message.type && message.type === "message") &&
                                <GenericMessage socket={socket} key={message.id} attr={message} userAttr={chatUsers[message.sender_id] ?? devs[message.sender_id] ?? null} end={message.sender_id === firstPerson.id} dev={dev} reloadChat={handleReloadChat} chatId={chatId} replyTo={replyTo} setReplyTo={setReplyTo} />
                                ||
                                (message.type && message.type === "deleted_notification") &&
                                <MessageDeletedMessage key={message.id} attr={message} userAttr={chatUsers[message.sender_id]} end={message.sender_id === firstPerson.id} dev={dev} />
                            )}
                        </div>
                    </div>
                </div>
                {
                    !isAtBottom &&
                    <div className="absolute bottom-0 ltr:right-5 rtl:left-5">
                        <div className="relative">
                            {
                                gotNewMessages &&
                                <button onClick={scrollToBottom} className="absolute animate-ping text-emerald-400 dark:text-emerald-200 scale-50 opacity-75"><FiArrowDownCircle size={40} /></button>
                            }
                            <button onClick={scrollToBottom} className={gotNewMessages ? "text-emerald-500 dark:text-emerald-300" : "text-gray-800 dark:text-gray-300"}><FiArrowDownCircle size={40} /></button>
                        </div>
                    </div>
                }

            </div>
        </>
    )
}


export const MessageDeletedMessage = ({ attr, userAttr, end, dev }) => {
    const { t } = useTranslation('edit')
    const time = formatTimestamp(attr.timestamp * 1000)

    if (!userAttr) {
        return <></>
    }

    return (
        <div className={`chat ${end ? "chat-end" : "chat-start"}`}>
            <div className={`chat-bubble group bg-gray-400 dark:bg-gray-500`}>

                <div className="chat-header flex items-center gap-4 justify-between">
                    <div className="flex gap-2">

                        <div className="chat-image avatar">

                            <div className="w-10 rounded-full">

                                {userAttr.avatar.length < 3 || (!dev) ?
                                    <div className="w-10 h-10 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-lg select-none">
                                        {userAttr.class === "dev" ? "GM" : userAttr.email[0].toUpperCase()}
                                    </div>
                                    :
                                    <img
                                        alt={userAttr?.name + " avatar"}
                                        src={setImageUrl(userAttr.avatar)} />

                                }
                            </div>
                        </div>
                        <div className="flex flex-col items-start">
                            <h1 className="text-black font-semibold">{userAttr.name}</h1>
                            <div className="flex gap-1 flex-wrap">
                                <time className="text-xs opacity-100 text-black">{time}</time>
                                <time className="text-xs opacity-100 text-black font-semibold">(<TimePassedComponent timestamp={attr.timestamp * 1000} />)</time>

                            </div>
                        </div>
                    </div>
                    <div className="grid grid-rows-2 gap-[1px] justify-items-end text-black text-xs">
                    </div>


                </div>
                <div className="divider before:h-[1px] after:h-[1px] mb-1 mt-[0px]"></div>
                <div className="text-black text-sm ltr:italic my-1">
                    <span>{t('Message deleted.')}</span>
                </div>

            </div>
        </div>
    )
}


export function DeveloperAssignedMessage({ fromAttr, toAttr }) {
    const { t } = useTranslation('edit')

    if (!toAttr) {
        return <></>
    }

    return (
        <div className="flex justify-center items-center gap-2 bg-yellow-100 dark:bg-yellow-700 border-2 border-yellow-200 dark:border-yellow-800 rounded-xl mx-2 py-2">
            <span className="px-2">
                {
                    fromAttr ?
                        <>
                            <Trans t={t} i18nKey={"Your ticket has been reassigned to an assistant:"} values={{ from: fromAttr.name, to: toAttr.name }} />
                        </>
                        :
                        <>
                            <Trans t={t} i18nKey={"Your ticket has been assinged an assistant:"} values={{ user: toAttr.name }} />
                        </>
                }
            </span>
        </div>
    )
}


export function TicketCompletedMessage({ message, users }) {
    const { t } = useTranslation('edit')

    if (message.user_id !== "AUTO" && !users[message.user_id]) {
        return <></>
    }

    return (
        <div className={`flex justify-center items-center gap-2 ${message.completedStatus === "RESOLVED" ? "bg-green-100 border-green-200 dark:bg-green-900 dark:border-green-800" : "bg-red-100 border-red-200 dark:bg-red-900 dark:border-red-800"} border-2  rounded-xl mx-2 py-2`}>
            <span className="px-2">
                {
                    message.completedStatus === "RESOLVED" ?
                        <Trans i18nKey="The ticket has been marked as RESOLVED" t={t} values={{ user: users[message.user_id].name }} />
                        :
                        message.user_id === "AUTO"
                            ?
                            <Trans i18nKey="auto_close_message" t={t} values={{ status: t("CLOSED"), hours: 72 }} />
                            :
                            <Trans i18nKey="The ticket has been marked as CLOSED" t={t} values={{ user: users[message.user_id].name }} />
                }
            </span>
        </div>
    )
}


export function TicketMemberResolved({ message, ticketInfo }) {
    const { t } = useTranslation('edit')


    return (
        <div className={`flex justify-center items-center gap-2 ${message.completedStatus === "RESOLVED" ? "bg-green-100 border-green-200 dark:bg-green-900 dark:border-green-800" : "bg-red-100 border-red-200 dark:bg-red-900 dark:border-red-800"} border-2  rounded-xl mx-2 py-2`}>
            <span className="px-2">
                <Trans i18nKey="The ticket has been marked as RESOLVED" t={t} values={{ user: t("User", { ns: "settings" }) }} />
            </span>
        </div>
    )
}


export function TicketReopenedMessage({ message, users }) {
    const { t } = useTranslation('edit')

    if (!users[message.user_id]) {
        return <></>
    }
    return (
        <div className={`flex justify-center items-center gap-2 bg-blue-100 border-2 border-blue-200 dark:bg-blue-900 dark:border-blue-800 rounded-xl mx-2 py-2`}>
            <span className="px-2">
                <Trans i18nKey="ticket_reopened_message" t={t} values={{ user: users[message.user_id].name }} />
            </span>
        </div>
    )
}



export function CategoryChangedMessage({ message }) {
    const { t } = useTranslation(['edit', 'common'])
    const { language } = useContext(AccountContext)
    const { categories } = useContext(ContentContext)

    return (
        <div className={`flex justify-center items-center gap-2 bg-yellow-100 dark:bg-yellow-700 border-2 border-yellow-200 dark:border-yellow-800 rounded-xl mx-2 py-2`}>
            <span className="px-2">
                <Trans
                    i18nKey="category_change_message"
                    t={t}
                    values={{
                        prev_category: categories[message.prev_category]?.locales?.[language] ? categories[message.prev_category]?.locales[language] : t(categories[message.prev_category].title, { 'ns': 'common' }),
                        new_category: categories[message.new_category]?.locales?.[language] ? categories[message.new_category]?.locales[language] : t(categories[message.new_category].title, { 'ns': 'common' })
                    }} />
            </span>
        </div>
    )
}


export function BannedUserMessage({ message }) {
    const { t } = useTranslation('edit')
    const { devs } = useContext(AccountContext)

    if (!devs[message.sender_id] && message.sender_id !== "AUTO") {
        return <></>
    }
    return (
        <div className={`flex justify-center items-center gap-2 ${message.banned ? "bg-red-600 dark:bg-red-800 text-white dark:border-red-800" : "bg-green-600 dark:bg-green-800 text-white dark:border-green-800"} border-2  rounded-xl mx-2 py-2`}>
            <span className="px-2">
                <Trans i18nKey={message.banned ? "banned_user_message.banned" : (message.sender_id === "AUTO" ? "banned_user_message.auto_unbanned" : "banned_user_message.unbanned")} t={t} values={{ sender_id: devs[message.sender_id]?.name }} />
            </span>
        </div>
    )
}


const ChatMessage = ({ message, dev }) => {
  const { devs } = useContext(AccountContext);
  const [parsedMessage, setParsedMessage] = useState([]);
  const findTicket = async ({ timestamp }) => {
    try {
        const response = await requestFetchTicketsByTimestamp({ timestamp, verbose: false });
        return response?.tickets?.[0] || null; 
    } catch (err) {
        console.error("Failed to fetch ticket:", err);
        return null;
    }
    };


  useEffect(() => {
    const parse = async () => {
      const parts = message.split(/(@\[[^\]]+\]\w+|\@\w+|\@[a-zA-Z0-9_\-]+|#\d+)/g);

      const parsedParts = await Promise.all(
        parts.map(async (part, index) => {
          // tagged user
          if (part.startsWith('@')) {
            const username = part.slice(1);
            const taggedUser = Object.values(devs).find(u => u.name === username);
            return taggedUser ? <TaggedUserComponent key={index} name={taggedUser.name} /> : part;
          }

          // tagged ticket
          if (part.startsWith('#')) {
            const ticketId = part.slice(1);
            const ticket = await findTicket({ timestamp: ticketId });
            return ticket ? <TaggedTicketComponent key={index} ticket={ticket} /> : part;
          }

          return part;
        })
      );

      setParsedMessage(parsedParts);
    };

    parse();
  }, [message, devs]);

  return <div>{parsedMessage}</div>;
};



const ParsedMessage = ({ message }) => {
    // Regular expression to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split the message into parts based on the regex
    const parts = message.split(urlRegex);

    return (
        <span className="whitespace-pre-wrap">
            {parts.map((part, index) =>
                urlRegex.test(part) ? (
                    // If the part matches the URL regex, render it as a link
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                    >
                        {part}
                    </a>
                ) : (
                    // Otherwise, render it as plain text
                    <span key={index}>{part}</span>
                )
            )}
        </span>
    );
};

const TaggedUserComponent = ({ name }) => (
    <span className="text-violet-500 dark:text-violet-400 font-semibold bg-white dark:bg-gray-700 rounded-md px-1 py-[2px]">@{name}</span>
);
const TaggedTicketComponent = ({ ticket }) => (
    <NavLink to={`http://localhost:3000/admin/${ticket.fetch_code}/edit`} 
    className="text-green-500 dark:text-green-400 font-semibold bg-white dark:bg-gray-700 rounded-md px-1 py-[2px]"
    >
      #{ticket.createdAt}
    </NavLink>
);

export const KeyboardKeyIcon = ({ text }) => {

    return (
        <kbd className="kbd kbd-xs bg-inherit border-white dark:group-disabled:border-gray-600 text-inherit group-disabled:bg-inherit group-disabled:border-inherit group-disabled:text-inherit">
            {text}
        </kbd>
    )
}

const getSessionItem = (key) => {
    return sessionStorage.getItem(key) || ""
}


export const MessageWriteComponent = ({ ticketInfo, user, handleSendMessage, handleSendAndComplete, completeInProgress, message, getData, replyTo, setReplyTo }) => {
    const { t } = useTranslation('edit')
    const { categories } = useContext(ContentContext)
    const textInputId = "main-message-reply-window"

    let savedMessageKey = `${ticketInfo.id}_${user.id}_msg`

    const [newMessage, setNewMessage] = useState(getSessionItem(savedMessageKey))
    const [newFiles, setNewFiles] = useState([])

    const [ctrlPressed, setCtrlPressed] = useState(false)
    const [ctrlShiftPressed, setCtrlShiftPressed] = useState(false)
    const submitCondition = (newMessage === "" && newFiles.length === 0) || !Object.keys(categories).includes(ticketInfo.category)

    const [focusTrigger, setFocusTrigger] = useState(false)

    const _setFiles = (f) => {
        f = f.filter((el) => {
            for (let i = 0; i < newFiles.length; i++) {
                if (newFiles[i].name === el.name && newFiles[i].lastModified === el.lastModified) {
                    return false
                }
            }
            return true
        })
        const _files = [...f, ...newFiles]
        setNewFiles(_files)
    }


    useEffect(() => {
        savedMessageKey = `${ticketInfo.id}_${user.id}_msg`
        setNewMessage(getSessionItem(savedMessageKey))
        setNewFiles([])
    }, [ticketInfo.id])

    useEffect(() => {
        if (ticketInfo.id && user.id) {
            if (newMessage === "") {
                sessionStorage.removeItem(savedMessageKey)
            }
            else {
                sessionStorage.setItem(savedMessageKey, newMessage)
            }
        }

        const handleKeyPress = (event) => {
            let element = document.getElementById(textInputId)
            if (event.ctrlKey) {

                if (element !== document.activeElement) {
                    return null;
                }

                setCtrlPressed(true)
                setCtrlShiftPressed(false)
                if (event.shiftKey) {
                    setCtrlShiftPressed(true)
                    if (event.key === "Enter") {
                        if (newMessage.trim() !== "") {
                            handleSendAndComplete(true, newMessage, newFiles)
                        }
                    }
                }

                else if (event.key === 'Enter') {
                    if (!submitCondition) {

                        onSendMessage()
                    }
                }
            }
        };

        const handleKeyUp = (event) => {
            if (event.key == "Control") {

                setCtrlPressed(false)
                setCtrlShiftPressed(false)
                if (ctrlPressed) {
                }
            }
            if (event.key == "Shift") {
                setCtrlShiftPressed(false)
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        document.addEventListener('keyup', handleKeyUp);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, [newMessage, newFiles]);


    const onSendMessage = () => {
        getData(newMessage, newFiles)
        const notReopen = handleSendMessage(newMessage, newFiles)
        if (notReopen) {
            setNewMessage("")
            setNewFiles([]);
        }
    }

    useEffect(() => {
        if (message === "#FINISHED#") {
            setNewMessage("")
            setNewFiles([])
        }
        if (message === "" && newMessage !== "") {
            setNewMessage(getSessionItem(savedMessageKey))
            setNewFiles([])
        }
    }, [message])

    useEffect(() => {
        if (completeInProgress) {
            setNewMessage("")
            setNewFiles([])
        }
    }, [completeInProgress])

    useEffect(() => {
        if (focusTrigger) {
            setFocusTrigger(false)
        }
    }, [focusTrigger])

    return (
        <div className="flex flex-col w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded-b-xl shadow-lg gap-3 py-5 pb-8">
            <div className="flex flex-col w-full px-3 gap-3">
                <div className="px-3">{replyTo?.type === "message" && t("Replying to") + ":"} {replyTo?.type === "message" && (
                    <div className="bg-gray-200 dark:bg-gray-600 p-2 rounded-md mb-2 flex justify-between items-center relative">
                        <span><strong>{replyTo.sender_name}</strong>: {replyTo.message}</span>
                        <MdClose 
                            className="font-bold absolute -top-2 -right-1.5 text-2xl bg-white rounded-full text-gray-500 cursor-pointer hover:scale-110 transition-all duration-200 ease-out" 
                            onClick={() => setReplyTo(null)}
                        />
                    </div>
                )}
                
                </div>
                <TextLargeInput
                    labelName={t("Message")}
                    placeHolder={t("Enter your reply...")}
                    classNames={"px-0"}
                    inputVariable={newMessage}
                    inputSetVariable={setNewMessage}
                    wFull={false}
                    id={textInputId}
                    limit={null}
                    focusTrigger={focusTrigger}
                />
                <div className="flex flex-col w-full justify-between gap-3 lg:gap-0">
                    <div className="flex w-full items-center">
                        <QuickReplyWindowExtended category={ticketInfo.category} setMessage={setNewMessage} setFocusTrigger={setFocusTrigger} />
                    </div>
                    <div className="flex gap-4 px-2 my-5">
                        {newFiles.map((file, index) => {
                            const isImage = file.type.startsWith("image/")
                            const fileUrl = URL.createObjectURL(file)
                            const isVideo = file.type.startsWith("video/")
                            return (
                                <div key={index} className="flex flex-col items-center">
                                    {isImage ? (
                                        <div className="relative">
                                            <div 
                                                onClick={() => setNewFiles(prev => prev.filter((_, i) => i !== index))} 
                                                className="absolute -right-3 -top-3 cursor-pointer rounded-full p-0.5 bg-red-600 text-white text-xl font-bold"
                                            >
                                                <MdClose />
                                            </div>
                                            <img
                                                src={fileUrl}
                                                alt={file.name}
                                                className="w-24 h-24 object-cover rounded border border-gray-500"
                                            />
                                        </div>
                                        ) : isVideo ? (
                                            <div className="relative">
                                                <div 
                                                    onClick={() => setNewFiles(prev => prev.filter((f, i) => i !== index))} 
                                                    className="absolute -right-3 -top-3 cursor-pointer rounded-full p-0.5 bg-red-600 text-white text-xl font-bold"
                                                >
                                                    <MdClose />
                                                </div>
                                                <video
                                                    src={fileUrl}
                                                    alt={file.name}
                                                    autoPlay
                                                    loop
                                                    className="w-24 h-24 object-cover rounded border border-gray-500"
                                                />
                                            </div>
                                        ) : (
                                        <div className="w-24 h-24 flex items-center justify-center bg-gray-200 text-xs rounded">
                                            {file.name.split(".").pop().toUpperCase()}
                                        </div>
                                        )}
                                        <p className="text-xs mt-1 truncate max-w-24">{file.name}</p>
                                </div>
                            )
                        })}
                    </div>
                    <div className="flex flex-col lg:flex-row w-full justify-between gap-3 lg:gap-0">

                        <div className="flex flex-col min-w-96">
                            <div className="flex md:flex-auto md:flex-grow-0 md:flex-shrink-0  w-full px-2">
                                <p className="font-semibold px-1">
                                    {t('Attachments')} <small>({t('You can select multiple files')})</small>
                                </p>
                            </div>
                            <FileInputExtended inputVariable={newFiles} inputSetVariable={_setFiles} inputId={1} />
                        </div>
                        <div className="flex items-center justify-center gap-2 mt-auto">
                            <button
                                className="btn bg-red-800 hover:bg-red-800/90 border-none text-white font-semibold"
                                disabled={submitCondition || (ticketInfo.status === "RESOLVED" || ticketInfo.status === "CLOSED") || (ticketInfo.assignedTo !== user.id && user.rank !== "admin")}
                                onClick={() => {
                                    handleSendAndComplete(false, newMessage, newFiles)
                                }}
                            >
                                {t('Submit')} <br />
                                {t('Close')}
                            </button>
                            <button
                                className={`btn btn-lg group  hover:bg-primary/90 border-none  font-semibold flex flex-col gap-0 ${ctrlPressed && !ctrlShiftPressed ? "bg-fuchsia-700 text-yellow-50" : "bg-primary text-white"}`}
                                disabled={submitCondition}
                                onClick={onSendMessage}
                            >
                                <div className="flex items-center justify-center gap-0 min-w-24">
                                    {
                                        (!ctrlPressed || submitCondition) &&
                                        <>
                                            <KeyboardKeyIcon text={"Ctrl"} />
                                            <a className="text-sm text-inherit">+</a>
                                        </>
                                    }
                                    <KeyboardKeyIcon text={"Enter"} />
                                </div>
                                {t('Submit')}
                            </button>
                            <button
                                className={`btn  hover:bg-green-800/90 border-none text-white font-semibold ${ctrlShiftPressed ? "bg-fuchsia-700 text-yellow-50" : "bg-green-800 text-white"}`}
                                disabled={submitCondition || (ticketInfo.status === "RESOLVED" || ticketInfo.status === "CLOSED") || (ticketInfo.assignedTo !== user.id && user.rank !== "admin")}
                                onClick={() => {
                                    handleSendAndComplete(true, newMessage, newFiles)
                                }}
                            >
                                {t('Submit')} <br />
                                {t("Resolve")}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}